import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NavBar from "components/NavBar/NavBar";
import "./App.css";
import { LandingPage } from "screen/landing/LandingPage";
import Footer from "components/Footer/Footer";

const App: React.FC = () => {
  return (
    <Router>
      <div >
        <NavBar />
          <div className="app-wrapper">
          <Routes>
          {/* Route for the landing page */}
          <Route path="/" Component={LandingPage} />
          {/* Fallback route to the landing page */}
          <Route path="/*" Component={LandingPage} />
          </Routes>
          </div>
          <Footer />
      </div>
    </Router>
  );
};

export default App;